module.exports = __webpack_public_path__ + "static/img/tu14.cb9dd9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tu14.png
// module id = pptc
// module chunks = 128